import { render, staticRenderFns } from "./HeWeiFang.vue?vue&type=template&id=6a4b94a8&scoped=true&"
import script from "./HeWeiFang.vue?vue&type=script&lang=js&"
export * from "./HeWeiFang.vue?vue&type=script&lang=js&"
import style0 from "./HeWeiFang.vue?vue&type=style&index=0&id=6a4b94a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b94a8",
  null
  
)

export default component.exports